module.exports = __webpack_public_path__ + "img/222.1208da17.jpg";